import React, { Component } from "react";
import { withStyles } from "@mui/styles";
import { Button, Grid, TextField, Box, Typography, Card } from "@mui/material";
// import Image from "../../../Image/KNS-icon.png";
import Image from "../../../Icons/knsLogoFullNameBg.png";
import hand from "../../../Image/hand.png";
import { connect } from "react-redux";
import { userRegister_action } from "../../../redux/User";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";

import classNames from "classnames";

const useStyles = (theme) => ({
  root: {
    backgroundColor: '#DFE3E6',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    width: 300,
    padding: 30,
    borderRadius: "25px !important",
    textAlign: 'center',
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    // borderRadius: "25px"
  },
  login: {
    // height:"100vh",
    backgroundColor: "#DFE3E6",
    textAlign: "center",
    height: "100vh",
    overflow: "hidden"
    // overflowX : "hidden",
    // overflowY : "hidden"
  },
  loginText: {
    color: "#393939",
    fontFamily: "Nunito Sans",
    fontSize: "25px",
    fontWeight: "bold"
  },
  loginContent: {
    color: "#707070",
    fontFamily: "Regular",
    fontSize: "14px",
    marginBottom: "20px"
  },
  icon: {
    marginTop: "62px"
  },
  logo: {
    marginBottom: 16,
    height: 100,
    width: 'auto',
  },
  homeIcon: {
    width: "128px",
    height: "150px",
    marginBottom: "15px",
    marginTop: "70px"
  },
  buttonContainer: {
    marginTop: 20,
    '& button': {
      backgroundColor: '#052e57',
      width: '50%',
      fontWeight: 'bold',
      borderRadius: 20,
      color: '#fff',
      '&:hover': {
        background: '#9e9e9e',
      },
    },
  },
   input: {
        marginTop: 10,
        marginBottom: 20,
        '& .MuiOutlinedInput-input': {
            padding: '11.5px 14px',
            color: '#575656',
        },
        '& .MuiOutlinedInput-root': {
            fontSize: 14,
            '&.Mui-focused fieldset': {
                borderColor: '#575656',
                borderWidth: 'thin',
            },
        },
        '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
    },
  GridBody: {
    // backgroundColor : "#FFFFFF",
    // borderRadius : "33px 33px 0 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // width: "335px",
    margin: "5px 10px 0px 10px",
    "& .Mui-focused": {
      color: "#393939 !important"
    }
  },
  Grid: {
    width: "335px",
    // height : "388px",
    display: "flex",
    marginTop: "15px",
    height: "333px"
  },
  GridItemWrapper: {
    display: "flex",             // Enables flex layout
    justifyContent: "center",    // Horizontal center
    alignItems: "center",        // Vertical center
    height: "100vh",             // Full screen height
    backgroundColor: "#f5f5f5",  // Optional: page background
  },
  GridItem: {
    width: "335px",
    color: "#000",
    marginTop: "64px",
    background: "#FFF",
    height: "600px",
    paddingTop: "64px",
    borderRadius: "33px 33px 33px 33px ",
    "& .MuiOutlinedInput-input": {
      padding: "11.5px 14px",
      // minWidth : "275px",
      // minHeight : "65px",
      outline: "0px !important",
      color: "#575656"
    },
    "& .Mui-focused": {
      outline: "0px !important",
      color: "#575656",
      border: "#575656 !important"
    },
    "& .MuiOutlinedInput-root": {
      fontSize: "14px",
      "&.Mui-focused fieldset": {
        borderColor: "#575656",
        borderSize: "1px",
        borderWidth: "thin"
      }
    },
    "&.Mui-focused fieldset": {
      borderColor: "#575656",
      borderWidth: "thin"
    },
    "& input": {
      width: "250px"
    },
    "& input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button":
    {
      "-webkit-appearance": "none",
      margin: "0"
    }
  },
  button: {
    marginTop: "59px",
    textAlign: "center",
    "& button": {
      backgroundColor: "#052e57",
      width: "300px",
      fontWeight: "bold",
      borderRadius: "20px",
      color: "#FFF !important",
      "&:hover": {
        background: "#9e9e9e"
      },
      [theme.breakpoints.down("md")]: {
        width: "200px"
      }
    }
  }
});

class Login extends Component {
  state = {
        mobileNumber: '',
        error: null,
    };



  getOTP = async () => {
    const phoneNo = this.state.mobileNumber;

    if (phoneNo.length == 10) {
      await this.props.userRegister({ mobileNo: this.state.mobileNumber });
      const { otp_sent } = this.props;
      if (otp_sent) {
        this.props.history.push({
          pathname: "/verifyOtp",
          state: this.state.mobileNumber
        });
      }
    } else {
      this.setState({
        error: "Please Enter Correct Mobile Number"
      });
    }
  };

  numberChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  };

  handleRegisterClick = () => {
    this.props.history.push("/cp-registration-form");
  };

  render() {
    const { classes } = this.props;
        const { mobileNumber, error } = this.state;

    return (
      <div className={classes.root}>
        <Card className={classes.card}>
          <img src={Image} alt="KNS Logo" className={classes.logo} />
          <Typography className={classes.subtitle}>Welcome to KNS Group</Typography>
          <br />
          <TextField
            required
            type="number"
            name="mobileNumber"
            label={<b>Mobile Number</b>}
            variant="outlined"
            fullWidth
            className={classes.input}
            value={mobileNumber}
            onChange={this.numberChange}
            error={!!error}
            helperText={error}
            InputLabelProps={{ shrink: true }}
          />
          <Box className={classes.buttonContainer}>
            <Button variant="contained" onClick={this.getOTP}>
              Get OTP
            </Button>
          </Box>

          
                  <br />
                  <Box className={classes.inlineContainer}>
                    <Typography variant="body1">
                      New to KNS Group?{" "}
                      <span
                        onClick={this.handleRegisterClick}
                        className={classes.registerLink}
                        style={{ cursor: "pointer", color: "#3f51b5" }}
                      >
                        Register as CP
                      </span>
                    </Typography>
                  </Box>
       
        </Card>
      </div>
    );
  }
}

const mapStatesToProps = (state) => {
  return {
    otp_sent: state.user.otp_sent
  };
};
const mapActionsToProps = {
  userRegister: userRegister_action
};
export default compose(
  connect(mapStatesToProps, mapActionsToProps),
  withStyles(useStyles),
  withRouter
)(Login);
